import { render, staticRenderFns } from "./calendar-facet-weekdays-font-size.vue?vue&type=template&id=eeb78fc2&"
import script from "./calendar-facet-weekdays-font-size.vue?vue&type=script&lang=js&"
export * from "./calendar-facet-weekdays-font-size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports